import axios from "axios";
import externalAPI from "./externalAPI";

const baseURL = process.env.REACT_APP_API_URL;

export const exchangeLaunchCode = ({ sessionUuid, data, signal } = {}) => {
  return axios
    .post(`${baseURL}/external/sessions/${sessionUuid}/exchange/`, data, {
      headers: { "Content-Type": "application/json" },
      signal,
    })
    .then((res) => res?.data);
};

// The start response already carries the whole attempt: the exam page takes
// it once from here instead of having the server build it a second time.
// A reload loses this module state and fetches as before.
let startedAttempt = null;

export const startSession = ({ sessionUuid, signal } = {}) => {
  return externalAPI
    .post(`/external/sessions/${sessionUuid}/start/`, {}, { signal })
    .then((res) => {
      startedAttempt = { sessionUuid, data: res?.data };
      return res?.data;
    });
};

export const getSessionStatus = ({ sessionUuid, signal } = {}) => {
  if (startedAttempt && startedAttempt.sessionUuid === sessionUuid) {
    const { data } = startedAttempt;
    startedAttempt = null;
    return Promise.resolve(data);
  }
  return externalAPI
    .get(`/external/sessions/${sessionUuid}/status/`, { signal })
    .then((res) => res?.data);
};

export const submitAnswer = ({ sessionUuid, data, signal } = {}) => {
  return externalAPI
    .post(`/external/sessions/${sessionUuid}/answer/`, data, { signal })
    .then((res) => res?.data);
};

export const submitSession = ({ sessionUuid, data = {}, signal } = {}) => {
  return externalAPI
    .post(`/external/sessions/${sessionUuid}/submit/`, data, { signal })
    .then((res) => res?.data);
};

export const getResult = ({ sessionUuid, signal } = {}) => {
  return externalAPI
    .get(`/external/sessions/${sessionUuid}/result/`, { signal })
    .then((res) => res?.data);
};
